<template>
  <div class="allWrap mt-5">
    <div class="inputWrap" v-if="timeMsg == ''">
      <h4 class="tit1 w-100 text-center">微信银行卡转帐</h4>
      <div class="row">
        <div class="col-12">
          <h5 class="ml-1 text-white text-left">转帐金额：¥{{order.real_price}}</h5>
        </div>
        <div class=" col-md-6 col-12">
          <div class="wallet_name m-0">
            <input
              class
              type="text"
              placeholder="请输入联络人帐号"
              onfocus="addInputStyle(this)"
              onblur="removeInputStyle(this)"
              disabled
            />
            <div class="icon">
              <div class="icon_bg">
                <i class="fa fas fa-user"></i>
              </div>
            </div>
            <p>帐号</p>
            <div class="account_name">
              <p>帐号</p>
              银行卡姓名 : {{order.bank_owner}}
              <em class="fas fa-user-lock lock"></em>
              <button v-clipboard:copy="order.bank_owner" class="btn btn-green copyBtn">复制</button>
            </div>
          </div>
        </div>
        <div class=" col-md-6 col-12">
          <div class="wallet_name m-0">
            <input
              class
              type="text"
              placeholder="请输入联络人帐号"
              onfocus="addInputStyle(this)"
              onblur="removeInputStyle(this)"
              disabled
            />
            <div class="icon">
              <div class="icon_bg">
                <i class="fa fas fa-user"></i>
              </div>
            </div>
            <p>帐号</p>
            <div class="account_name">
              <p>帐号</p>
              银行卡号 : {{order.bank_no}}
              <em class="fas fa-user-lock lock"></em>
              <button v-clipboard:copy="order.bank_no" class="btn btn-green copyBtn">复制</button>
            </div>
          </div>
        </div>
        <div class=" col-md-6 col-12">
          <div class="wallet_name m-0">
            <input
              class
              type="text"
              placeholder="请输入联络人帐号"
              onfocus="addInputStyle(this)"
              onblur="removeInputStyle(this)"
              disabled
            />
            <div class="icon">
              <div class="icon_bg">
                <i class="fa fas fa-user"></i>
              </div>
            </div>
            <p>帐号</p>
            <div class="account_name">
              <p>帐号</p>
              开户银行 : {{order.bank_name}}
              <em class="fas fa-user-lock lock"></em>
              <button v-clipboard:copy="order.bank_name" class="btn btn-green copyBtn">复制</button>
            </div>
          </div>
        </div>
        <div class=" col-md-6 col-12" v-if="order.memo_id">
          <div class="wallet_name m-0">
            <input
              class
              type="text"
              placeholder="请输入联络人帐号"
              onfocus="addInputStyle(this)"
              onblur="removeInputStyle(this)"
              disabled
            />
            <div class="icon">
              <div class="icon_bg">
                <i class="fa fas fa-user"></i>
              </div>
            </div>
            <p>备注</p>
            <div class="account_name">
              <p>备注</p>
              备注 :{{order.memo_id}}
              <em class="fas fa-user-lock lock"></em>
              <button v-clipboard:copy="order.memo_id" class="btn btn-green copyBtn">复制</button>
            </div>
          </div>
          <p class="text-danger text-right w-100">↑请务必填写此备注，否则充值将无法成功到帐!</p>
        </div>
      </div>

      <p class="ml-2 mt-1 text-left">操作步骤</p>
      <p class="ml-2 mt-1 text-left">
        1.打开微信→点击右上角
        <span class="text-danger">"+"</span>号→收付款→转帐到银行卡
      </p>
      <p class="ml-2 mt-1 text-left">
        2.务必填写金额
        <span class="text-danger">{{order.real_price}}</span>元，否则不到帐
      </p>
      <p class="ml-2 mt-1 text-left">3.微信提示两小时到帐，实际2分钟内到帐</p>
      <p class="ml-2 mt-1 text-left">支付成功后到帐，请放心支付</p>
    </div>
    <div v-else>
      <h4 class="tit1">{{timeMsg}}</h4>
    </div>
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
import axios from "axios";
export default {
  data() {
    return {
      order: "",
      timeout: "",
      timeMsg: ""
    };
  },
  computed: {},
  methods: {
    onCopy(e) {
      // alert('You just copied: ' + e.text)
    },
    onError(e) {
      // alert('Failed to copy texts')
    },
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}/aaa/query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            this.order = res.data.data;
          } else {
            this.timeMsg = res.data.message;
            clearInterval(this.timeout);
          }
        });
    }
  },
  created() {
    this.getOrder();
    this.timeout = setInterval(() => this.getOrder(), 60000);
  }
};
</script>